import * as actions from './actions';

export default function (state = {}, action) {
  switch (action.type) {

  case actions.SET_FIELDS:
    return action.fields;

  default:
    return state;
  }
}
